import { createMuiTheme } from '@material-ui/core/styles';
import onaBetBackground from 'images/background_onabet.png';

// Create a theme instance.
export const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#333333',
    },
    secondary: {
      main: '#FF283C',
    },
    listOpened: {
      main: '#1EC6A8',
    },
    listSelected: '#fc842b',
    background: {
      list: '#173963',
      nested: '#63504c',
    },
  },
  typography: {
    fontFamily: 'Poppins'
  },
  shape: {
    borderRadius: 20,
  },
  spacing: 0,
  overrides: {
    MuiButtonBase: {
      root: {
        color: '#fff !important'
      },
    },
    MuiTableHead: {
      root: {
        background: '#030000',
        backgroundColor: '#FF283C'
      }
    },
    MuiTableCell: {
      root: {
        backgroundColor: 'transparent !important'
      },
      header: {
        backgroundColor: 'transparent !important'
      },
      body: {
        color: '#fff !important'
      }
    },
    MuiTableBody: {
      root: {
        backgroundColor: '#333333',
        color: '#fff',
      }
    },
    MuiDataGrid: {
      root: {
        backgroundColor: '#333333',
        color: '#fff',
      }
    },
    MuiCheckbox: {
      root: {
        color: '#f2f2f2',
      }
    },
    MuiSvgIcon: {
      root: {
        fill: '#f2f2f2'
      }
    },
    MuiMenuItem: {
      root: {
        background: "#333333",
        justifyContent: 'center',
        color: '#fff',
        '@media(max-width: 600px)': {
          minHeight: 'auto'
        },
      }
    },
    MuiTypography: {
      root: {
        color: '#fff',
      }
    },
    MuiInputBase: {
      root: {
        '& .Mui-disabled': {
          backgroundColor: '#f2f2f2',
        }
      },
    },
    MuiIconButton: {
      root: {
        '&:hover': { backgroundColor: '#FF283C' }
      },
    },
    MuiTooltip: {
      tooltip: {
        fontSize: 14
      }
    },
    MuiCssBaseline: {
      '@global': {
        html: {},
        body: {
          fontSize: 16,
          fontFamily: 'Poppins',
          backgroundColor: '#333333',
          color: '#183B56',
          backgroundImage: `url('${onaBetBackground}')`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover'
        },
      },
    },
    MuiContainer: {
      maxWidthLg: {
        padding: 0,
        maxWidth: 1140,
        '@media(min-width: 1280px)': {
          maxWidth: 1140,
        },
      },
    },
    MuiButton: {
      root: {
        backgroundColor: '#FFFFFF',
        textTransform: 'none',
        '&:hover': {
          backgroundColor: '#FFFFFF8f',
        },
      },
      containedPrimary: {
        background: '#FF283C !important',
        fontFamily: 'Poppins-Medium',
        fontSize: '20px'
      },
      contained: {
        color: 'white',
      },
      text: {
        color: 'white',
        fontWeight: 'bold',
      },
      label: {
        padding: '0px 10px',
      },
      outlined: {
        backgroundColor: 'transparent',
        border: '1px solid #FFFFFF8f',
        color: '#FFFFFF',
        '&:hover': {
          color: 'white',
        },
      },
    },
    MuiInput: {
      underline: {
        '&::before': {
          border: 'none',
        },
        '&::after': {
          border: 'none',
        },
        '&:hover:not(.Mui-disabled):before': {
          border: 'none',
        },
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0,
        backgroundColor: '#333333',
        color: '#fff',
      },
      notchedOutline: {
        border: '1px solid #FF283C !important',
      },
      adornedEnd: {
        paddingRight: 0,
        '& .MuiIconButton-root': {
          padding: '15px',
          borderRadius: '0px',
          border: 'none',
        },
        '& .MuiIconButton-edgeEnd': {
          marginRight: '0px'
        }
      },
    },
    MuiAppBar: {
      colorPrimary: {
        color: '#6A707E',
        backgroundColor: '#030000',
        boxShadow: 'rgba(0, 0, 0, 0.25) 0px 14px 28px, rgba(0, 0, 0, 0.22) 0px 10px 10px',
      },
    },
    MuiListItem: {
      root: {
        // color: '#FFF !important'
      },
      button: {
        '&:hover': {
          backgroundColor: '#FF283C'
        }
      }
    },
    MuiPaper: {
      elevation8: {
        backgroundColor: 'transparent !important',
        boxShadow: 'none'
      },
      elevation2: {
        backgroundColor: 'transparent !important',
        boxShadow: 'none'
      },
    },
  },
  MuiListItemText: {
    root: {
      color: '#fff'
    }
  },
  MuiPaper: {
    outlined: {
      padding: 20,
    },
  },
  MuiCheckbox: {
    color: '#fc842b !important',
    fill: '#fc842b !important',
    colorSecondary: {
      color: '#fc842b !important',
      fill: '#fc842b !important',
      '&$checked': {
        color: '#fc842b !important',
      },
    },
    colorPrimary: {
      color: '#fc842b !important',
      fill: '#fc842b !important',
      '&$checked': {
        color: '#fc842b !important',
      },
    },
  },
  props: {
    MuiInputLabel: {
      style: { color: '#464A53' },
    },
    MuiFormControl: {
      fullWidth: true,
    },
  
    MuiTab: {
      disableRipple: true,
    },
    MuiButtonBase: {
      disableRipple: true,
    },
    MuiButton: {
      disableRipple: true,
    },
    MuiCheckbox: {
      disableRipple: true,
    },
    MuiTextField: {
      variant: 'outlined',
      margin: 'normal',
      autoComplete: 'off',
      fullWidth: true,
      // defaultValue: '',
      InputLabelProps: {
        shrink: true,
        style: { color: '#FF283C' },
      },
    },
    MuiPaper: {
      elevation: 8,
    },
    MuiCard: {
      elevation: 8,
    },
    MuiOutlinedInput: {},
  },
});
